import React from 'react'
import { RowActionMenuButtonLink, RowActionMenuItem, TableRowAction } from '@ztechapps/webui.data-tools'
import { useTaskListContext } from '../Context'
import type { TaskListRowActionMenuProps } from '@ztechapps/webui.contract'
import { useInject, WebuiIocKey } from '@ztechapps/webui.contract'
import type { RouteDef, Task } from '@ztechapps/common.contract'
import { getWindow } from '@ztechapps/common.utils'
import { useDeleteTaskWithConfirm } from '../../shared/useDeleteTaskWithConfirm'

export const RowAction = ({ task, showActionButtons }: { task: Task; showActionButtons: boolean }) => {
  const { components, ...context } = useTaskListContext()

  return (
    <TableRowAction
      showQuickActions={showActionButtons}
      firstQuickAction={<DeleteRowActionMenu task={task} />}
      secondQuickAction={<OpenInNewWindowRowActionMenu task={task} />}
    >
      <DeleteRowActionMenu task={task} as={RowActionMenuItem} />
      <OpenInNewWindowRowActionMenu task={task} as={RowActionMenuItem} />

      <components.rowAction task={task} as={RowActionMenuItem} taskListContext={{ ...context, components }} />
    </TableRowAction>
  )
}

export const DeleteRowActionMenu = ({ task, as }: TaskListRowActionMenuProps) => {
  const As = as || RowActionMenuButtonLink
  const { disabled } = useTaskListContext()
  const { onDelete, deleting } = useDeleteTaskWithConfirm()

  const onClick = (e) => {
    e?.preventDefault()
    onDelete(task?._id)
  }

  return (
    <As
      icon="trash"
      label="Delete this task?"
      disabled={disabled}
      isBusy={deleting}
      className="text-danger"
      onClick={onClick}
    />
  )
}

const OpenInNewWindowRowActionMenu = ({ task, as }: TaskListRowActionMenuProps) => {
  const taskId = task?._id

  const taskDetailRoute = useInject<RouteDef>(WebuiIocKey.routes.taskItem)
  const win = getWindow().window

  const As = as || RowActionMenuButtonLink
  const onClick = () => {
    const route = taskDetailRoute.altPath({ _id: taskId })
    win.open(route, '_blank')
  }
  return <As icon="external-link" label="Open in new window" onClick={onClick} />
}
